import React from 'react';

import { useIntl } from 'react-intl-next';

import AkFlag, { type FlagProps } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';

import { withLocalIntl } from '../../common/utils/i18n/intl-provider';

import { messages } from './messages';

export type Props = {
	flagComponent?: React.ElementType;
	id: FlagProps['id'];
	onDismiss: FlagProps['onDismissed'];
};

export const RequestAccessSuccessFlag: (props: Props) => React.JSX.Element = withLocalIntl(
	({ onDismiss, flagComponent: FlagComponent = AkFlag, ...props }: Props) => {
		const { formatMessage } = useIntl();

		return (
			<FlagComponent
				{...props}
				icon={
					<SuccessIcon spacing="spacious" label="Success" color={token('color.icon.success')} />
				}
				onDismissed={onDismiss}
				title={formatMessage(messages.title)}
				description={formatMessage(messages.description)}
			/>
		);
	},
);
